import React, { memo, useState, useEffect } from "react";
import { connect } from "react-redux";
import { Panel, PanelHeader, PanelBody } from "../../components/panel/panel.jsx";
import {
  GetVehicles,
  GetSpots,
  ToggleArchiveParking,
} from "../../redux/actions/parking";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import ParkingForm from "./parkingForm";
import SweetAlert from "react-bootstrap-sweetalert";
import { useTranslation } from "react-i18next";

const ParkingList = memo(
  ({
    parking = [],
    GetVehicles,
    GetSpots,
    ToggleArchiveParking,
    loader,
    Leases,
  }) => {
    const [modalDialog, setModalDialog] = useState(false);
    const [selectedItem, setSelectedItem] = useState({});
    const [openAlert, setOpenAlert] = useState(false);
    const [selectedArchived, setSelectedArchived] = useState("");
    const [edit, setEdit] = useState(false);
    const [showNotAassiged, setShowNotAssigned] = useState(false);
    const { t } = useTranslation();

    useEffect(() => {
      if (Leases && Leases.length) {
        GetVehicles();
        GetSpots();
      }
      // eslint-disable-next-line
    }, [Leases]);

    const toggleModal = (e) => {
      e && e.stopPropagation();
      setModalDialog(!modalDialog);
    };

    const closeModal = () => {
      setModalDialog(false);
      setEdit(false);
      setSelectedItem({});
    };

    const closeModalAdd = () => {
      setModalDialog(false);
      setEdit(false);
      setSelectedItem({});
      setShowNotAssigned(true);
    };

    const handleToggleParking = () => {
      const item = parking[selectedArchived];
      if (!item) return;
      const isArchived = item.isArchived ? "" : "1";
      ToggleArchiveParking(item.zzID, { isArchived }, closeModal);
      setOpenAlert(false);
    };

    const openParkingAlert = (e, index) => {
      e.stopPropagation();
      if (index !== undefined && index !== null && index !== "") {
        setSelectedArchived(index);
      }
      setOpenAlert(true);
    };

    return (
      <div>
        {openAlert && (
          <SweetAlert
            showCancel
            confirmBtnText={t("modal.parking.sweetalert.continue")}
            confirmBtnBsStyle="info"
            cancelBtnBsStyle="default"
            title={t("modal.parking.sweetalert.title")}
            onConfirm={() => handleToggleParking()}
            onCancel={() => {
              setSelectedArchived("");
              setOpenAlert(false);
            }}
          />
        )}

        {showNotAassiged && (
          <SweetAlert
            confirmBtnBsStyle="info"
            cancelBtnBsStyle="default"
            title={t("modal.parking.no-designated-spot")}
            onConfirm={() => setShowNotAssigned(false)}
            onCancel={() => setShowNotAssigned(false)}
          />
        )}

        <Modal isOpen={modalDialog} toggle={() => toggleModal()}>
          <ModalHeader toggle={() => closeModal()}>
            {edit
              ? t("modal.parking.header-edit-parking")
              : t("modal.parking.header-add-parking")}
          </ModalHeader>
          <ModalBody>
            <ParkingForm
              item={selectedItem}
              edit={edit}
              openParkingAlert={openParkingAlert}
              closeModal={closeModal}
              closeModalAdd={closeModalAdd}
            />
          </ModalBody>
        </Modal>
        <Panel>
          <PanelHeader noButton={true}>
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <div className="stats-title text-uppercase text-white font-weight-bold">
                  {t("card-title.parking")}
                </div>
                <div className="stats-desc">
                  {t("card-subtitle.parkingv2")}
                </div>
              </div>
              {Leases && Leases.length > 0 && (
                <button
                  className="btn btn-warning btn-icon"
                  onClick={(e) => toggleModal(e)}
                >
                  <i className="fa fa-plus" />
                </button>
              )}
            </div>
          </PanelHeader>
          <PanelBody>
            <div className="table-responsive">
              <table className="table">
                <thead>
                  <tr>
                    <th className="text-nowrap">{t("card-table.parking.year")}</th>
                    <th className="text-nowrap">{t("card-table.parking.make")}</th>
                    <th className="text-nowrap">{t("card-table.parking.model")}</th>
                    <th className="text-nowrap">{t("card-table.parking.color")}</th>
                    <th className="text-nowrap">{t("card-table.parking.license")}</th>
                    <th className="text-nowrap">{t("card-table.parking.state")}</th>
                    <th className="text-nowrap">{t("card-table.parking.spot")}</th>
                    <th className="text-nowrap">{t("card-table.parking.status")}</th>
                    <th className="text-nowrap"></th>
                  </tr>
                </thead>
                <tbody>
                  {parking?.map((item, i) => (
                    <tr
                      key={item.zzID || i}
                      className={`text-nowrap ${
                        !item.isArchived
                          ? "hover-pointer"
                          : "hover-not text-muted font-italic"
                      }`}
                      onClick={(e) => {
                        if (!item.isArchived) {
                          setEdit(true);
                          setSelectedItem(item);
                          setSelectedArchived(i);
                          toggleModal(e);
                        }
                      }}
                    >
                      <td className={item.isArchived ? "text-strikethrough" : ""}>
                        {item.Year || "-"}
                      </td>
                      <td className={item.isArchived ? "text-strikethrough" : ""}>
                        {item.Make || "-"}
                      </td>
                      <td className={item.isArchived ? "text-strikethrough" : ""}>
                        {item.Model || "-"}
                      </td>
                      <td className={item.isArchived ? "text-strikethrough" : ""}>
                        {item.Color || "-"}
                      </td>
                      <td className={item.isArchived ? "text-strikethrough" : ""}>
                        {item.LicensePlate || "-"}
                      </td>
                      <td className={item.isArchived ? "text-strikethrough" : ""}>
                        {item.RegisteredState || "-"}
                      </td>
                      <td className={item.isArchived ? "text-strikethrough" : ""}>
                        {item.SpotNumber || "-"}
                      </td>
                      <td>
                        <div className="btn-group btn-group-justified">
                          {item.isArchived ? (
                            <button
                              disabled={loader}
                              className="btn btn-sm btn-default"
                              style={{ textDecoration: "none" }}
                              onClick={(e) => openParkingAlert(e, i)}
                            >
                              {t("modal.parking.activate")}
                            </button>
                          ) : (
                            <button
                              disabled={loader}
                              className="btn btn-sm btn-default"
                              onClick={(e) => openParkingAlert(e, i)}
                            >
                              {t("modal.parking.archive")}
                            </button>
                          )}
                        </div>
                      </td>
                      <td className="text-center">
                        <i className="fa fa-chevron-right" />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </PanelBody>
        </Panel>
      </div>
    );
  }
);

const mapStateToProps = ({ USER_REDUCER, PARKING_REDUCER }) => {
  return {
    parking: PARKING_REDUCER.vehicles,
    loader: PARKING_REDUCER.loading,
    user: USER_REDUCER.userData,
    Leases: USER_REDUCER.AllLeases,
  };
};

export default connect(mapStateToProps, {
  GetVehicles,
  GetSpots,
  ToggleArchiveParking,
})(ParkingList);
